export default class AmbraNamespaceRepository {
  constructor({ ambraNamespaceService }) {
    this.ambraNamespaceService = ambraNamespaceService;
  }

  getAmbraNamespace(criteria) {
    return this.ambraNamespaceService.getAmbraNamespace(criteria);
  }
}
